import { render, staticRenderFns } from "./OrdersCount.vue?vue&type=template&id=f60bf36a&"
import script from "./OrdersCount.vue?vue&type=script&lang=js&"
export * from "./OrdersCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports